import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ISagaCb } from '@typings/requestPayloads'

export interface ICreateTablePayload extends ISagaCb {
    data: any
}

export interface ICreateTableState {
    status: string
    data: any
    errors: any
}

const initialState: ICreateTableState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const createTable = createSlice({
    name: 'table/create',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<ICreateTablePayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const createTableActions = createTable.actions
export default createTable.reducer
